import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import ControlModel from '../../models/controlModel';
import { MODEL_CONTROL_TYPE } from '../../utils/enums';
import ChooseRegionsFromTemplate from '../../app/components/ChooseRegionsFromTemplate';
import IconButton from '../../app/components/IconButton';

export function createRegionTemplatesControlModel({ ...args }) {
  return new ControlModel({
    text: args.text || '',
    tooltipText: args.tooltipText || '',
    customStyles: args.customStyles || null,
    isShow:
      args.isShow ||
      function() {
        return true;
      },
    type: MODEL_CONTROL_TYPE.regionTemplates,
  });
}

export const RegionTemplatesControl = ({ control }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <div className={classNames('chooseRegionsFromTemplateControl')}>
      <div className={classNames('chooseTemplateButton')} onClick={() => setOpen(true)}>
        <span className={classNames('chooseTemplateButtonText')}>
          {control.text || t('settings.regionTemplates.LABEL')}
        </span>
        <IconButton isIcon iconName={'regionTemplate'} />
      </div>
      <div className={classNames('chooseRegionsFromTemplateOverlay', { open: open })} />
      <ChooseRegionsFromTemplate open={open} onClose={() => setOpen(false)} />
    </div>
  );
};
